module.exports = __webpack_public_path__ + "static/media/logo.46d7a664.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/images/logo.svg
// module id = ./src/assets/images/logo.svg
// module chunks = 0